import React from "react";
import "./style.css";
import japanImage from "../../assets/japan.webp";
import Particles from "../Particles/Particles";
import university1 from "../../assets/university-logos/japan/Heisie_University.webp";
import university2 from "../../assets/university-logos/japan/Mirai_University.webp";
import university3 from "../../assets/university-logos/japan/Nihon_Sports_University.webp";
import university4 from "../../assets/university-logos/japan/Tokiwa_University.webp";
import university5 from "../../assets/university-logos/japan/ibaraki_University.webp";

const universityList = [
  { id: Math.random(), image: university1 },
  { id: Math.random(), image: university2 },
  { id: Math.random(), image: university3 },
  { id: Math.random(), image: university4 },
  { id: Math.random(), image: university5 },
];

const Japan = () => {
  return (
    <>
      <Particles
        title="Study in Japan"
        subTitle="Start Your Journey to Japan Today"
        image={japanImage}
      />
      <div className="short-description container">
        <h1 className="text-left">Study in Japan</h1>
        <p className="text-justify">
          Japan has welcomed international students for years and values them as
          part of its society and economy. The country is renowned for blending
          ancient traditions with modern innovation, offering a unique and
          vibrant cultural environment. With seasonal festivals, innovative
          technology, and safe, clean cities, Japan provides an enriching
          experience for students worldwide.
          <br />
          <br />
          Divided into 47 prefectures, many regions host top-ranked universities
          and colleges that attract thousands of international students
          annually. While Japanese is the official language, many institutions
          offer programs entirely in English—and living in Japan is an excellent
          way to learn Japanese while exploring a vibrant new culture.
        </p>
      </div>

      <div className="why-study container">
        <h1 className="text-left">Why study in Japan?</h1>
        <p className="text-left">
          Japan is increasingly recognized as a top destination for
          international students. Here’s why:
        </p>
        <ul className="nav nav-tabs" id="myTab" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className="nav-link active"
              id="first-tab"
              data-bs-toggle="tab"
              data-bs-target="#first"
              type="button"
              role="tab"
              aria-controls="first"
              aria-selected="true"
            >
              Elite Learning & Innovation
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              id="second-tab"
              data-bs-toggle="tab"
              data-bs-target="#second"
              type="button"
              role="tab"
              aria-controls="second"
              aria-selected="false"
            >
              Economical Fees
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              id="third-tab"
              data-bs-toggle="tab"
              data-bs-target="#third"
              type="button"
              role="tab"
              aria-controls="third"
              aria-selected="false"
            >
              Safe, Rich Cultural Life
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              id="fourth-tab"
              data-bs-toggle="tab"
              data-bs-target="#fourth"
              type="button"
              role="tab"
              aria-controls="fourth"
              aria-selected="false"
            >
              Tech Career
            </button>
          </li>
        </ul>
        <div className="tab-content" id="myTabContent">
          <div
            className="tab-pane show active"
            id="first"
            role="tabpanel"
            aria-labelledby="first-tab"
          >
            <h6>
              Japan is home to globally respected universities like the
              University of Tokyo, Kyoto, Osaka, and Nagoya—frequently ranked
              among the best worldwide. These institutions offer rigorous
              academic systems, strong research output, especially in science
              and engineering, and modern labs for cutting‑edge studies
              :contentReference.
            </h6>
          </div>
          <div
            className="tab-pane"
            id="second"
            role="tabpanel"
            aria-labelledby="second-tab"
          >
            <h6>
              Tuition fees in Japan are generally lower than in Western
              countries, and many schools offer generous scholarships—such as
              MEXT and JASSO awards—that can fully cover tuition, living
              expenses, and travel. Students may also work part‑time (up to
              28 hrs/week) to offset living costs.
            </h6>
          </div>
          <div
            className="tab-pane"
            id="third"
            role="tabpanel"
            aria-labelledby="third-tab"
          >
            <h6>
              Japan is consistently ranked among the safest countries worldwide,
              featuring clean, efficient public transport and excellent
              healthcare. Its rich culture—from cherry blossoms and tea
              ceremonies to modern festivals—adds depth to the experience
              :contentReference
            </h6>
          </div>
          <div
            className="tab-pane"
            id="fourth"
            role="tabpanel"
            aria-labelledby="fourth-tab"
          >
            <h6>
              Japan is at the forefront of technology, with giants like Toyota,
              Sony, and Panasonic headquartered here. Universities maintain
              strong industry ties, providing internships, research
              collaborations, and post‑study career pathways—especially as Japan
              seeks global talent. English‑based programs, such as Nagoya’s
              Global 30 and other Top Global University initiatives, facilitate
              study and work in English environments
            </h6>
          </div>
        </div>
      </div>

      <div className="university-partners container">
        <h1 className="text-left">Our University Partners in Japan</h1>
        <div className="row">
          {universityList?.map((list) => (
            <div key={list.id} className="col-6 col-md-4 col-lg-3 p-2">
              <div className="partner-box">
                <img src={list.image} alt="university logo" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Japan;
